import { Component, OnInit} from '@angular/core';
import { NavigationService } from '../../services/navigation.service';
import { RegistrationService } from '../../services/registration.service';
import { ListManagerService } from '../../services/list-manager.service';
import { EnrollmentService } from '../../services/enrollment.service';
import _ from 'lodash';
import { PhoneService } from 'src/app/services/phone.service';
import { VariablesService } from 'src/app/services/variables.service';

@Component({
    templateUrl: './attendee.component.html',
    standalone: false
})
export class AttendeeComponent implements OnInit {
  isSubmitting = false;
  isError = false;
  attendee;
  prefixList;
  suffixList;
  workPhone;
  homePhone;
  mobilePhone;
  workAddress;
  homeAddress;
  emailAddress;
  adminContact;
  adminPhone;
  emerContact;
  emerContactMainPhone;
  emerContactAltPhone;
  DisabilityType;
  mealList;
  personalConsiderationsList;
  $mtcverifyEmailAddress;
  $mtcMailToAddress;
  isRegComplete;
  enrollment;
  answer;
  isFormCompleted = false;

  dealerCode;
  partsAccountNum;
  starsID;
  jobTitleList;
  otherJobTitle;
  verifyMobile;
  phoneAck;
  
  clickedCountry;
  childEventClicked(data) {
    this.clickedCountry = data;
  }


  constructor(
    private navigationService: NavigationService,
    private registrationService: RegistrationService,
    private listService: ListManagerService,
    private enrollmentService: EnrollmentService,
    private variablesService: VariablesService,
    private phoneService: PhoneService
  ) {

    this.enrollment = this.registrationService.getEnrollment({});
    this.isRegComplete = this.registrationService.isRegistrationComplete();
    /* this.enrollment.HotelNeeded = "false"; */
    if(!this.enrollment.$mtcverifyMobile ){
      this.enrollment.$mtcverifyMobile={
        "PhoneType": "MOBILE",
        "PhoneNo": "",
        "AreaCityCode": "",
        "CountryCode": "01"
      }
    }


    this.attendee = this.registrationService.getAttendee({});
    this.workPhone = this.registrationService.getPhone(this.attendee, "WORK", {});
    this.homePhone = this.registrationService.getPhone(this.attendee, "HOME", {});
    this.mobilePhone = this.registrationService.getPhone(this.attendee, "MOBILE", {});
    this.workAddress = this.registrationService.getAddress(this.attendee, "WORK", {});
    this.homeAddress = this.registrationService.getAddress(this.attendee, "HOME", {});
    this.emailAddress = this.registrationService.getEmail(this.attendee, "BUSINESS", {});
    this.verifyMobile= this.enrollment.$mtcverifyMobile;

    this.adminContact = this.registrationService.getAdminContact({});
    this.adminPhone = this.adminContact.AdminContactPhone[0];
    this.emerContactMainPhone = this.registrationService.getEmergencyContactPhone(this.attendee, "DTPHONE", {});
    this.emerContactAltPhone = this.registrationService.getEmergencyContactPhone(this.attendee, "ALTPHONE", {});

    //this.dealerCode = this.registrationService.getVariable(this.attendee,variablesService.VARIABLE.dealerCode.ID,{});
    this.partsAccountNum= this.registrationService.getVariable( this.attendee, this.variablesService.VARIABLE.partsAcctNo.ID, {} );
    //this.starsID= this.registrationService.getVariable( this.attendee, this.variablesService.VARIABLE.starsID.ID, {} );
    this.phoneAck = registrationService.getVariable(this.attendee, variablesService.VARIABLE.phoneAcknowledgment.ID, {});

    this.DisabilityType = this.registrationService.getDisabilities(this.attendee, "");
    if(this.workAddress.CountryISOCode === "" || this.workAddress.CountryISOCode === " " || this.workAddress.CountryISOCode === undefined){
      this.workAddress.CountryISOCode = "US";
    }

    if(this.homeAddress.CountryISOCode === "" || this.homeAddress.CountryISOCode === " " || this.homeAddress.CountryISOCode === undefined){
      this.homeAddress.CountryISOCode = "US";
    }




    if(this.attendee.ResidenceCountryISOCode && this.workAddress.CountryISOCode){
      if(this.attendee.ResidenceCountryISOCode == this.workAddress.CountryISOCode){
        this.attendee.$mtcvarCountryOfRes = 'Yes';
      }else{
        this.attendee.$mtcvarCountryOfRes = 'No';
      }
    }

    this.jobTitleList = [
      { title: "Dealer Principal" },
      { title: "General Manager" },
      { title: "Other" }
    ];


    this.listService.getCommonPrefixList().then(list => {
      this.prefixList = list;
    });
    this.listService.getSuffixList().then(list => {
      this.suffixList = list;
    });
    this.listService.getMealPreferenceList().then(list => {
      this.mealList = list;
    });
    this.listService.getDisabilityList().then(list => {
      this.personalConsiderationsList = list;
    });

    /*if(this.attendee.JobTitle){
      let jt= _.find(this.jobTitleList,{title:this.attendee.JobTitle})
      if(jt===undefined){
        this.otherJobTitle=this.attendee.JobTitle;
        this.attendee.JobTitle="Other";
        
      }
    }*/

    this.detectMailTo();
    this.setMailTo();

  }

  ngOnInit(): void { 
    if(this.attendee.PAXTypeNo == 7) this.enrollment.$mtcHasAdminContact=true;
  }

  includes(arr, val){
    return _.includes(arr, val);
  }

  considerationUpdate(consideration) {
    let justadded = false;

    if (!_.includes(this.attendee.DisabilityType, consideration.code)) {
      this.attendee.DisabilityType.push(consideration.code);
      justadded = true;
    }
    if (justadded === false && _.includes(this.attendee.DisabilityType, consideration.code)) {
      var index = this.attendee.DisabilityType.indexOf(consideration.code);
      if (index !== -1) {
        this.attendee.DisabilityType.splice(index, 1);
      }
    }
  }

  FieldsChange(values:any) {
    if (values.checked) {
      this.homeAddress.AddressLine1 = this.workAddress.AddressLine1;
      this.homeAddress.AddressLine2 = this.workAddress.AddressLine2;
      this.homeAddress.Zip = this.workAddress.Zip;
      this.homeAddress.City = this.workAddress.City;
      this.homeAddress.StateProvince = this.workAddress.StateProvince;
      this.homeAddress.CountryISOCode = this.workAddress.CountryISOCode;
    } else {
      this.homeAddress.AddressLine1 = "";
      this.homeAddress.AddressLine2 = "";
      this.homeAddress.Zip = "";
      this.homeAddress.City = "";
      this.homeAddress.StateProvince = "";
      this.homeAddress.CountryISOCode = "";
    }
  }
  cleanAdminContact() {
    if (!this.enrollment.$mtcHasAdminContact) {
        this.adminContact.AdminContactName = undefined;
        this.adminContact.AdminContactEmailAddress = undefined;
        this.adminContact.AdminContactPhone = undefined;
    }
  }
  cleanConsiderations() {
    if (!(this.attendee.DietaryNeed === "FOODALLE") && !(this.attendee.DietaryNeed === "OTHER")) {
      this.attendee.DietaryConsiderations = undefined;
    }
    if (this.attendee.DisabilityType) {

      if (!_.includes(this.attendee.DisabilityType, 'OTHER')) {
        this.attendee.PersonalConsiderations = undefined;
      }
    }
    // if (!this.attendee.$mtcHasConsiderations) {
    //     this.attendee.DietaryNeed = undefined;
    //     this.attendee.DietaryConsiderations = undefined;
    //     this.attendee.DisabilityType = undefined;
    //     this.attendee.PersonalConsiderations = undefined;
    // } else if (this.attendee.DietaryNeed === undefined && this.attendee.DisabilityType.length === 0) {
    //   this.attendee.$mtcHasConsiderations = false;
    // }
  }

  mtcMailToAddress;

  detectMailTo(){

    var hasValue=false;
    if(this.attendee){

      this.attendee.Address.forEach(add => {
        if(add.MailTo){
          this.mtcMailToAddress = add.AddressType;
          hasValue=true;
        }
      });

      if(hasValue==false){
        this.attendee.Address.forEach(el => {
          if(el.AddressType =='WORK'){
            el.MailTo=true;
            this.mtcMailToAddress=el.AddressType;
          }
        });
      }

    }

  }

  setMailTo(){
    if(this.attendee){
      this.attendee.Address.forEach(add => {
        if(add.AddressType === this.mtcMailToAddress){
          add.MailTo = true;
        }else{
          add.MailTo = false;
        }
      });
    }
    this.phoneService.triggeredChange();
  }


  forward(form) {
    this.isSubmitting = true;
    this.isFormCompleted = true;
    console.log(form);
    if (form.valid) {
      this.cleanAdminContact();
      /*/this.cleanConsiderations();
      if(this.attendee.JobTitle==="Other"){
        this.attendee.JobTitle=this.otherJobTitle;
      }*/

      this.navigationService.forward();
    } else {
      this.isError = true;
      this.isSubmitting = false;

    }
  }

  back() {
    this.navigationService.back();
  }

  isDealer(attPaxtypeNo){
    //return '1234'.includes(attPaxtypeNo);
    return false;
  }
}
